import React, { Component } from "react";
import { Images } from "../../../components";
import { connect } from "react-redux";

export class HomeBanner extends Component {
  render() {
    const { luckyNumberConfigration } = this.props;
    return (
      <div className="home-banner">
        <img
          src={luckyNumberConfigration.websiteBannerPath}
          alt="marketing-banner"
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    connected: state.signalr.luckyNumbersConnected,
    luckyNumberConfigration: state.general.luckyNumberConfigration,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(HomeBanner);
